import { render, staticRenderFns } from "./DirectorShiftsSchedule.vue?vue&type=template&id=c6c56ebe&lang=pug&"
import script from "./DirectorShiftsSchedule.vue?vue&type=script&lang=js&"
export * from "./DirectorShiftsSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports